import React, { useEffect } from 'react';

import $ from 'jquery'

import './styles.css';
import loading_gif from './assets/loading-gif.gif'

export default function Loading() {

  useEffect(() => {
    $(window).on("load", function() {
      $(".loading-container").delay(1000).fadeOut('slow')
    })
  }, [])

  return (
    <container className="loading-container">
      <img src={loading_gif} alt="Loading Gif" />

      <svg id="name" width="100" height="100" viewBox="0 0 240 86" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M85.498 0.959991V84H74.578V22.08L46.978 84H39.298L11.578 21.96V84H0.657974V0.959991H12.418L43.138 69.6L73.858 0.959991H85.498Z" stroke="#7bd4e8" strokeWidth="5"/>
        <path d="M111.937 50.88C111.937 44.16 113.297 38.28 116.017 33.24C118.737 28.12 122.457 24.16 127.177 21.36C131.977 18.56 137.297 17.16 143.137 17.16C148.897 17.16 153.897 18.4 158.137 20.88C162.377 23.36 165.537 26.48 167.617 30.24V18.24H178.657V84H167.617V71.76C165.457 75.6 162.217 78.8 157.897 81.36C153.657 83.84 148.697 85.08 143.017 85.08C137.177 85.08 131.897 83.64 127.177 80.76C122.457 77.88 118.737 73.84 116.017 68.64C113.297 63.44 111.937 57.52 111.937 50.88ZM167.617 51C167.617 46.04 166.617 41.72 164.617 38.04C162.617 34.36 159.897 31.56 156.457 29.64C153.097 27.64 149.377 26.64 145.297 26.64C141.217 26.64 137.497 27.6 134.137 29.52C130.777 31.44 128.097 34.24 126.097 37.92C124.097 41.6 123.097 45.92 123.097 50.88C123.097 55.92 124.097 60.32 126.097 64.08C128.097 67.76 130.777 70.6 134.137 72.6C137.497 74.52 141.217 75.48 145.297 75.48C149.377 75.48 153.097 74.52 156.457 72.6C159.897 70.6 162.617 67.76 164.617 64.08C166.617 60.32 167.617 55.96 167.617 51Z" stroke="#7bd4e8" strokeWidth="5"/>
        <path d="M222.431 27.24V66C222.431 69.2 223.111 71.48 224.471 72.84C225.831 74.12 228.191 74.76 231.551 74.76H239.591V84H229.751C223.671 84 219.111 82.6 216.071 79.8C213.031 77 211.511 72.4 211.511 66V27.24H202.991V18.24H211.511V1.67999H222.431V18.24H239.591V27.24H222.431Z" stroke="#7bd4e8" strokeWidth="5"/>
      </svg>


    </container>
  );
}
